import React from 'react'
import { CircularProgress, Typography } from '@mui/material'
import { useParams } from 'react-router-dom'
import { RouterRouteId } from '../../../../routers/_props'
import useStyles from '../_styles/PatientFormModificationsHistoryStyles'
import { usePatientFormContext } from '../../context/PatientFormContext'
import { PatientFormModificationsHistoryProps } from './_props'
import PatientFormModificationsHistoryRows from './PatientFormModificationsHistoryRows'
import { sortHistoryRows } from './_utils'
import useCurrentHcs from '../../../../hooks/useCurrentHcs'
import { usePatientFormModificationsHistory } from '../../../../hooks/usePatientFormModificationsHistory'

const PatientFormModificationsHistory = ({ margin }: PatientFormModificationsHistoryProps) => {
    const classes = useStyles()

    const { state } = usePatientFormContext()
    const currentHcs = useCurrentHcs()
    const { id } = useParams<RouterRouteId>()

    const { historyRows, insHistoryRows, isHistoryLoading, isInsiHistoryLoading, isHistoryError, isInsiHistoryError } =
        usePatientFormModificationsHistory({
            hcsId: currentHcs?.id ?? '',
            patientId: id ?? '',
            isEditMode: state.mode === 'EDITION',
        })

    const renderHistory = () => {
        if (isHistoryError) return <Typography>Erreur lors du chargement de l'historique</Typography>
        if (isHistoryLoading) {
            return <CircularProgress />
        }
        if (historyRows && historyRows.length > 0) {
            return (
                <PatientFormModificationsHistoryRows
                    historyRows={sortHistoryRows(historyRows)}
                    label="Afficher l'historique de toutes les modifications"
                    displayMostRecentAction
                />
            )
        }
        return <Typography>Aucun historique de modifications</Typography>
    }

    const renderInsiHistory = () => {
        if (isInsiHistoryError) return <Typography>Erreur lors du chargement de l'historique INSI</Typography>
        if (isInsiHistoryLoading) return <CircularProgress />
        if (insHistoryRows && insHistoryRows.length > 0) {
            return (
                <PatientFormModificationsHistoryRows
                    historyRows={sortHistoryRows(insHistoryRows)}
                    label="Afficher l'historique de toutes les modifications INS"
                />
            )
        }
        return null
    }

    return (
        <div
            className={classes.PatientFormModificationsHistory}
            style={{
                margin,
            }}
        >
            {renderHistory()}
            {renderInsiHistory()}
        </div>
    )
}

export default PatientFormModificationsHistory
